import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  Autocomplete,
} from "@mui/material";

import { useAlert } from "../../hooks";
import { LoadingButton } from "./../../components";
import TextField from "./../../components/TextField";

const MobileNumberInput = ({
  loading,
  onSubmit,
  setMobileNumber,
  mobileNumber,
  handleUserConsentChange,
  handleGoBack,
  whatsappCheck,
  setWhatsappCheck,
  countryCodes,
  selectedCountryCode,
  setSelectedCountryCode,
  uuid,
}) => {
  const { alert } = useAlert();
  const dispatch = useDispatch();

  const handleMobileNumberChange = (event) => {
    const inputNumber = event.target.value;

    // Remove any non-digit characters from the input
    const cleanedInput = inputNumber.replace(/\D/g, "");

    // Check if the cleaned input starts with 6, 7, 8, or 9
    setMobileNumber(cleanedInput);
    // if (/^[6-9]/.test(cleanedInput) || cleanedInput === "") {
    // }
  };

  const handleGetOTP = () => {
    if (!/^[0-9]+$/.test(mobileNumber)) {
      // console.log(mobileNumber);
      dispatch(
        alert({
          type: "error",
          message: "Please enter a valid mobile number.",
        })
      );
      return;
    }
    sessionStorage.setItem("mobileNumber", mobileNumber);
    onSubmit(mobileNumber);
  };

  return (
    <form style={{ width: "100%" }}>
      <Grid
        container
        spacing={2}
        style={{ margin: "20px 0px 15px 0px", width: "100%" }}
        alignItems="center"
      >
        <Grid item xs={4.5}>
          <Autocomplete
            disableClearable
            options={
              countryCodes && countryCodes.length > 0
                ? countryCodes
                : [
                    {
                      alpha2_code: "IN",
                      dial_code: "91",
                      country_name: "India",
                    },
                  ]
            }
            getOptionLabel={(option) => {
              const code = String(
                option.dial_code || option.country_code || option.code || ""
              ).replace("+", "");
              const name =
                option.country_name || option.country || option.name || "";
              return name ? `+${code} (${name})` : `+${code}`;
            }}
            disabled={!!uuid}
            value={
              (countryCodes &&
                countryCodes.find(
                  (item) =>
                    (item.alpha2_code ||
                      item.code ||
                      item.country_code ||
                      item.dial_code ||
                      "") === selectedCountryCode
                )) ||
              (selectedCountryCode === "IN"
                ? {
                    alpha2_code: "IN",
                    dial_code: "91",
                    country_name: "India",
                  }
                : null)
            }
            onChange={(event, newValue) => {
              if (newValue) {
                const val =
                  newValue.alpha2_code ||
                  newValue.code ||
                  newValue.country_code ||
                  newValue.dial_code ||
                  "";
                setSelectedCountryCode(val);
              }
            }}
            isOptionEqualToValue={(option, value) => {
              const optVal =
                option.alpha2_code ||
                option.code ||
                option.country_code ||
                option.dial_code ||
                "";
              const valVal =
                value.alpha2_code ||
                value.code ||
                value.country_code ||
                value.dial_code ||
                "";
              return optVal === valVal;
            }}
            renderOption={(props, option) => {
              const code = String(
                option.dial_code || option.country_code || option.code || ""
              ).replace("+", "");
              const name =
                option.country_name || option.country || option.name || "";
              const val =
                option.alpha2_code ||
                option.code ||
                option.country_code ||
                option.dial_code ||
                "";
              return (
                <li {...props} key={val} style={{ fontSize: "14px" }}>
                  {name ? `+${code} (${name})` : `+${code}`}
                </li>
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                size="small"
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid item xs={7.5} style={{ paddingLeft: "16px" }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Mobile Number"
            disabled={!!uuid}
            inputProps={{
              type: "tel",
              inputMode: "numeric",
              maxLength: 20,
              //             pattern: "[6-9]\\d*", // Pattern to match numbers starting with 6, 7, 8, or 9
            }}
            size="small"
            value={mobileNumber}
            onChange={handleMobileNumberChange}
          />
        </Grid>
      </Grid>

      <Grid
        item
        container
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: "10px",
          marginTop: "20px",
        }}
      >
        <Grid item xs={12}>
          <LoadingButton
            loading={loading}
            onClick={handleGetOTP}
            style={{ padding: "10px 12.5px", fontWeight: 700 }}
          >
            Get OTP
          </LoadingButton>
        </Grid>

        <FormControlLabel
          control={
            <Checkbox
              sx={{
                color: "rgba(0, 24, 236, 0.71)",
                "&.Mui-checked": {
                  color: "rgba(0, 24, 236, 0.71)",
                },
              }}
              checked={whatsappCheck}
              onClick={() => setWhatsappCheck(!whatsappCheck)}
            />
          }
          label="This Number is available on Whatsapp"
          onClick={handleUserConsentChange}
          style={{ fontWeight: "900 !important" }}
        />
      </Grid>
    </form>
  );
};

export default MobileNumberInput;
